module.exports = __webpack_public_path__ + "static/media/DetailsIcon.3b731d1f.svg";